import { ConfigKey } from './types.ts';

export const getConfig = (key: ConfigKey): any => {
  const viteKey = `VITE_${key}`;
  return import.meta.env[viteKey];
};
